// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull reader-web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 32
 * Build: 1.0.0
 * Runtime: browser:javascript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/redshelf/RedShelf/implementation/reader-web)
 */

import * as amplitude from '@amplitude/analytics-browser';

/**
 * @typedef BaseEvent
 * @type {object}
 * @property {string} event_type
 * @property {Object.<string, *>} [event_properties]
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} [branch]
 * @property {string} [source]
 * @property {string} [version]
 * @property {string} [versionId]
 */

/**
 * @typedef LoadClientOptions
 * @type {object}
 * @property {string} [apiKey]
 * @property {Object} [configuration]
 * @property {BrowserClient} [instance]
 */

/**
 * @typedef LoadOptions
 * @type {object}
 * @property {'production'|'development'} [environment]
 * @property {boolean} [disabled]
 * @property {LoadClientOptions} [client]
 */

/**
 * @typedef {Object} EventOptions
 * @type {object}
 */

/**
 * @typedef ApiKey
 * @type {object}
 * @property {string} production
 * @property {string} development
 */
export const ApiKey = {
  production: 'd698e26b8252a5f2a4d0ef933291fa00',
  development: '36a942b0061ac1a1beb1a7b75d147376',
};

/**
 * @typedef {Object} SuperProperties
 * @param {string} [bookEisbn10] Property has no description in tracking plan.
 * @param {string} [bookEisbn13] Property has no description in tracking plan.
 * @param {*} [bookId] Property has no description in tracking plan.
 * @param {string} [bookIdSession] Property has no description in tracking plan.
 * @param {string} [bookIsbn] Property has no description in tracking plan.
 * @param {string} [bookIsbn10] Property has no description in tracking plan.
 * @param {string} [bookIsbn13] Property has no description in tracking plan.
 * @param {string} [bookPublisherName] Property has no description in tracking plan.
 * @param {string} [bookTitle] Property has no description in tracking plan.
 * @param {string} [courseId] Property has no description in tracking plan.
 * @param {string} [courseName] Property has no description in tracking plan.
 * @param {string} [defaultOptingStatus] Property has no description in tracking plan.
 * @param {string} [departmentId] Property has no description in tracking plan.
 * @param {string} [departmentName] Property has no description in tracking plan.
 * @param {string} [instructorName] Property has no description in tracking plan.
 * @param {string} [optingPlanID] Property has no description in tracking plan.
 * @param {string} [optingProgramName] Property has no description in tracking plan.
 * @param {string} [optingProgramType] Property has no description in tracking plan.
 * @param {string} [productType] Property has no description in tracking plan.
 * @param {string} [sectionId] Property has no description in tracking plan.
 * @param {string} [sectionName] Property has no description in tracking plan.
 * @param {string} [termEndDate] Property has no description in tracking plan.
 * @param {string} [termId] Property has no description in tracking plan.
 * @param {string} [termName] Property has no description in tracking plan.
 * @param {string} [termStartDate] Property has no description in tracking plan.
 * @param {string} [universityId] Property has no description in tracking plan.
 * @param {string} [universityName] Property has no description in tracking plan.
 */

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration = {
  plan: {
    version: '32',
    branch: 'main',
    source: 'reader-web',
    versionId: 'a8e8a610-e3f4-47e1-8cd0-82c67e26c374',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-javascript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export class Identify {
  constructor(properties) {
    this.event_type = amplitude.Types.SpecialEventType.IDENTIFY;
    this.event_properties = properties;
  }
}

export class BookmarkCreated {
  constructor(properties) {
    this.event_type = 'Bookmark Created';
    this.event_properties = properties;
  }
}

export class CitationCreated {
  constructor(properties) {
    this.event_type = 'Citation Created';
    this.event_properties = properties;
  }
}

export class CollaborationMenuOpen {
  constructor(properties) {
    this.event_type = 'Collaboration Menu Open';
    this.event_properties = properties;
  }
}

export class CollaborationNoteSubscribed {
  constructor(properties) {
    this.event_type = 'Collaboration Note Subscribed';
    this.event_properties = properties;
  }
}

export class DownloadToOfflineMenuOpen {
  constructor(properties) {
    this.event_type = 'Download to Offline Menu Open';
    this.event_properties = properties;
  }
}

export class FlashcardCreated {
  constructor(properties) {
    this.event_type = 'Flashcard Created';
    this.event_properties = properties;
  }
}

export class HighlightCreated {
  constructor(properties) {
    this.event_type = 'Highlight Created';
    this.event_properties = properties;
  }
}

export class MyShelfClicked {
  constructor(properties) {
    this.event_type = 'My Shelf Clicked';
    this.event_properties = properties;
  }
}

export class NoteCreated {
  constructor(properties) {
    this.event_type = 'Note Created';
    this.event_properties = properties;
  }
}

export class OfflineDelete {
  constructor(properties) {
    this.event_type = 'Offline Delete';
    this.event_properties = properties;
  }
}

export class OfflineDownload {
  constructor(properties) {
    this.event_type = 'Offline Download';
    this.event_properties = properties;
  }
}

export class PageViewed {
  constructor(properties) {
    this.event_type = 'Page Viewed';
    this.event_properties = properties;
  }
}

export class PrintToPdfMenuOpen {
  constructor(properties) {
    this.event_type = 'Print to PDF Menu Open';
    this.event_properties = properties;
  }
}

export class SearchMenuOpen {
  constructor(properties) {
    this.event_type = 'Search Menu Open';
    this.event_properties = properties;
  }
}

export class SubmitATicketClicked {
  constructor(properties) {
    this.event_type = 'Submit a Ticket Clicked';
    this.event_properties = properties;
  }
}

export class SwitchToV6 {
  constructor(properties) {
    this.event_type = 'Switch to v6';
    this.event_properties = properties;
  }
}

export class TableOfContentsMenuOpen {
  constructor(properties) {
    this.event_type = 'Table of Contents Menu Open';
    this.event_properties = properties;
  }
}

export class TtsStarted {
  constructor(properties) {
    this.event_type = 'TTS Started';
    this.event_properties = properties;
  }
}

export class V7IntroModal {
  constructor(properties) {
    this.event_type = 'V7 Intro Modal';
    this.event_properties = properties;
  }
}

export class V7OptOutReaderVersionSelected {
  constructor(properties) {
    this.event_type = 'V7 Opt Out Reader Version Selected';
    this.event_properties = properties;
  }
}

/**
 * @typedef PromiseResult
 * @type {object}
 * @property {Promise|undefined} promise
 */

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  constructor() {
    /* @type {BrowserClient|undefined} */
    this.amplitude = undefined;
    this.disabled = false;
  }

  /**
   * @return {BrowserClient}
   */
  get client() {
    this.isInitializedAndEnabled();
    return this.amplitude;
  }

  /**
   * @return {boolean}
   */
  get isLoaded() {
    return this.amplitude != null;
  }

  /**
   * @private
   * @return {boolean}
   */
  isInitializedAndEnabled() {
    if (!this.isLoaded) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param {LoadOptions} options Configuration options to initialize the Ampli SDK with. 'environment', 'client.apiKey' or 'client.instance' is required.
   *
   * @return {PromiseResult}
   */
  load(options) {
    this.disabled = options?.disabled ?? false;

    if (this.isLoaded) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey;
    if (options?.client?.apiKey) {
      apiKey = options.client.apiKey;
    } else if (options?.environment) {
      apiKey = ApiKey[options.environment];
    }

    if (options?.client?.instance) {
      this.amplitude = options?.client?.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options?.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set or update that user's properties.
   *
   * @param {string|undefined} userId The user's id.
   * @param {Object} [properties] The user's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.classroomRole] A user's role in the classroom application
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  identify(userId, properties, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options, user_id: userId};
    }

    const ampIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        ampIdentify.set(key, value);
      }
    }
    return this.amplitude.identify(ampIdentify, options);
  }

  /**
  * Flush the event.
  */
  flush() {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.flush();
  }

  /**
   * Track event
   *
   * @param {BaseEvent} event The event to track.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  track(event, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.track(event, undefined, options);
  }

  /**
   * Bookmark Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Bookmark%20Created)
   *
   * When a user creates a bookmark.
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  bookmarkCreated(properties, options) {
    return this.track(new BookmarkCreated(properties), options);
  }

  /**
   * Citation Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Citation%20Created)
   *
   * A citation is created from Annotation Modal. This is just to check if user use this feature.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  citationCreated(properties, options) {
    return this.track(new CitationCreated(properties), options);
  }

  /**
   * Collaboration Menu Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Collaboration%20Menu%20Open)
   *
   * Track if Collaboration Menu is open, click on `Note Sharing` button in `Additional Options` Menu
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  collaborationMenuOpen(properties, options) {
    return this.track(new CollaborationMenuOpen(properties), options);
  }

  /**
   * Collaboration Note Subscribed
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Collaboration%20Note%20Subscribed)
   *
   * Tracks the successful subscription of other users notes and highlights through collaboration - note sharing feature. This event fires when a user successfully subscribes to other users notes by opening collaboration menu, going to Share and Subscribe tab, entering other users code and successfully subscribing.
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  collaborationNoteSubscribed(properties, options) {
    return this.track(new CollaborationNoteSubscribed(properties), options);
  }

  /**
   * Download to Offline Menu Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Download%20to%20Offline%20Menu%20Open)
   *
   * Tracks if Offline Menu is open by clicking on `Download for Offline` button in `Additional Options` Menu
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  downloadToOfflineMenuOpen(properties, options) {
    return this.track(new DownloadToOfflineMenuOpen(properties), options);
  }

  /**
   * Flashcard Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Flashcard%20Created)
   *
   * When a user creates a flashcard.
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  flashcardCreated(properties, options) {
    return this.track(new FlashcardCreated(properties), options);
  }

  /**
   * Highlight Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Highlight%20Created)
   *
   * When a user creates a highlight.
   *
   * Owner: Alex Ho
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} properties.color Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.highlight_id] Property has no description in tracking plan.
   * @param {string} [properties.HighlightColorChange] Property has no description in tracking plan.
   * @param {string} [properties.HighlightPage] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  highlightCreated(properties, options) {
    return this.track(new HighlightCreated(properties), options);
  }

  /**
   * My Shelf Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/My%20Shelf%20Clicked)
   *
   * User clicked `My Shelf` to go back to shelf.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  myShelfClicked(properties, options) {
    return this.track(new MyShelfClicked(properties), options);
  }

  /**
   * Note Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Note%20Created)
   *
   * When a user creates a note from the annotation modal
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  noteCreated(properties, options) {
    return this.track(new NoteCreated(properties), options);
  }

  /**
   * Offline Delete
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Offline%20Delete)
   *
   * This event tracks when a user deletes a downloaded chapter from their offline session. The "offlineDeleteType" property in the event is used to determine if the event was fired from "Clear All" button or "Delete" icon button.
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} properties.offlineDeleteType describes how offline delete event has been triggered
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  offlineDelete(properties, options) {
    return this.track(new OfflineDelete(properties), options);
  }

  /**
   * Offline Download
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Offline%20Download)
   *
   * This event tracks when a user initiates an offline download of a chapter in eReader.  
   *  The "offlineDownloadType" property in the event is used to determine if the event was fired from "Download All" button or "Download" icon button.
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} properties.offlineDownloadType describes how offline download event has been triggered
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  offlineDownload(properties, options) {
    return this.track(new OfflineDownload(properties), options);
  }

  /**
   * Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Page%20Viewed)
   *
   * Any time a new page is accessed in the eReader.  Page is defined as 'new CFI entry' on the Reader platform.
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {number} [properties.pageIndex] index value of the page within the book
   * @param {string} properties.pageNumber Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  pageViewed(properties, options) {
    return this.track(new PageViewed(properties), options);
  }

  /**
   * Print Menu Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Print%20to%20PDF%20Menu%20Open)
   *
   * Print Pages to PDF Menu in Additional Options Menu is opened.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  printToPdfMenuOpen(properties, options) {
    return this.track(new PrintToPdfMenuOpen(properties), options);
  }

  /**
   * Search Menu Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Search%20Menu%20Open)
   *
   * Search Menu in Top MenuBar is opened.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  searchMenuOpen(properties, options) {
    return this.track(new SearchMenuOpen(properties), options);
  }

  /**
   * Submit a Ticket Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Submit%20a%20Ticket%20Clicked)
   *
   * This tracks if `Submit a Ticket` linked is clicked to submit an issue through Redshelf solve page.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  submitATicketClicked(properties, options) {
    return this.track(new SubmitATicketClicked(properties), options);
  }

  /**
   * Switch to v6
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Switch%20to%20v6)
   *
   * User has gone into the Additional Options menu and elected to flip their reader version back to V6.
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  switchToV6(properties, options) {
    return this.track(new SwitchToV6(properties), options);
  }

  /**
   * Table of Contents Menu Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/Table%20of%20Contents%20Menu%20Open)
   *
   * Table of contents menu in the top Menu Bar is opened.
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  tableOfContentsMenuOpen(properties, options) {
    return this.track(new TableOfContentsMenuOpen(properties), options);
  }

  /**
   * TTS Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/TTS%20Started)
   *
   * User hits the play button from the annotation modal OR the main TTS bar.  There is a property to track which one they used, but this is the overall engagement of TTS.
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} properties.TTSLocation Property has no description in tracking plan.
   * @param {string} [properties.TTSPage] Property has no description in tracking plan.
   * @param {string} [properties.TTSVoice] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  ttsStarted(properties, options) {
    return this.track(new TtsStarted(properties), options);
  }

  /**
   * V7 Intro Modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/V7%20Intro%20Modal)
   *
   * Owner: Lisa Keefe
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {*} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {*} [properties.bookTitle] Property has no description in tracking plan.
   * @param {*} [properties.v7IntroModalOption] Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  v7IntroModal(properties, options) {
    return this.track(new V7IntroModal(properties), options);
  }

  /**
   * V7 Opt Out Reader Version Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/redshelf/RedShelf/events/main/latest/V7%20Opt%20Out%20Reader%20Version%20Selected)
   *
   * Reader version selected by user when presented with Opt-out Dialog
   *
   * Owner: Ritesh Maharjan
   *
   * @param {Object} properties The event's properties.
   * @param {string} [properties.bookEisbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookEisbn13] Property has no description in tracking plan.
   * @param {*} [properties.bookId] Property has no description in tracking plan.
   * @param {string} [properties.bookIdSession] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn10] Property has no description in tracking plan.
   * @param {string} [properties.bookIsbn13] Property has no description in tracking plan.
   * @param {string} [properties.bookPublisherName] Property has no description in tracking plan.
   * @param {string} [properties.bookTitle] Property has no description in tracking plan.
   * @param {string} [properties.courseId] Property has no description in tracking plan.
   * @param {string} [properties.courseName] Property has no description in tracking plan.
   * @param {string} [properties.defaultOptingStatus] Property has no description in tracking plan.
   * @param {string} [properties.departmentId] Property has no description in tracking plan.
   * @param {string} [properties.departmentName] Property has no description in tracking plan.
   * @param {string} [properties.instructorName] Property has no description in tracking plan.
   * @param {string} [properties.optingPlanID] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramName] Property has no description in tracking plan.
   * @param {string} [properties.optingProgramType] Property has no description in tracking plan.
   * @param {string} [properties.productType] Property has no description in tracking plan.
   * @param {string} [properties.sectionId] Property has no description in tracking plan.
   * @param {string} [properties.sectionName] Property has no description in tracking plan.
   * @param {string} [properties.termEndDate] Property has no description in tracking plan.
   * @param {string} [properties.termId] Property has no description in tracking plan.
   * @param {string} [properties.termName] Property has no description in tracking plan.
   * @param {string} [properties.termStartDate] Property has no description in tracking plan.
   * @param {string} [properties.universityId] Property has no description in tracking plan.
   * @param {string} [properties.universityName] Property has no description in tracking plan.
   * @param {boolean} properties.v7optOut if user switched to v6
   * @param {EventOptions} [options] Options for this track call.
   */
  v7OptOutReaderVersionSelected(properties, options) {
    return this.track(new V7OptOutReaderVersionSelected(properties), options);
  }
}

export const ampli = new Ampli();
